import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  ApplicationRouteURL,
  PermissionType
} from "../../shared/config";
import { ErrorEscalationModel } from "../models/errorescalation.model";
import { TranslateService } from "../../shared/translate/index";
import { ErrorEscalationService } from "../models/errorescalation.service";
import { AuthService } from "../../shared/models/auth.service";
import { DropdownModel } from "../../report/models/report-filter.model";
import { InstanceService } from "../../instance/models/instance.service";
import { CustomerService } from "../../customer/models/customer.service";
const $ = require("jquery");
const moment = require("moment");
const SlimSelect = require("slim-select");

@Component({
  selector: "error-escalation",
  template: require('../views/errorescalation-update.component.html'),
  providers: [ErrorEscalationService, InstanceService, CustomerService]
})
export class ErrorEscalationUpdateComponent implements OnInit, OnDestroy {
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
  public itemsPerPage: number = WeGoConfig.GRID_MAX_DATA_SIZE;
  private errorEscalationHashId: string;
  private sub: any;
  isLoading: boolean;
  model: ErrorEscalationModel;
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  componentList: DropdownModel[];
  //logTypeList: DropdownModel[];
  logTypeList: { Key: string; Value: string }[];
  wegoAdminList: DropdownModel[];
  instanceList: DropdownModel[];
  instanceAdminList: DropdownModel[];
  customerList: DropdownModel[];
  customerAdminList: DropdownModel[];
  wegoAdminMultiSelect: any;
  instanceAdminMultiSelect: any;
  customerAdminMultiSelect: any;
  tempInstanceAdminList: string[] = [""];
  tempCustomerAdminList: string[] = [""];
  urlErrorEsclationUpdate: string;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  private apiErrorMsg: string;
  public bindFirstTime: boolean;
  public searchField: string = "";
  public searchTerm: string = "";
  duplicateEscalationMsg: string;

  urlDefaultPage: string;
  urlErrorEscalationList: string;
  LblDuplicateEscalation: string;

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("duplicateEscalationPopup") public duplicateEscalationPopup: any;
  constructor(
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private locationService: Location,
    private errorEscalationService: ErrorEscalationService,
    private instanceService: InstanceService,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.logTypeList = [
      {
        Key: "ERROR",
        Value: "ERROR"
      },
      {
        Key: "WARNING",
        Value: "WARNING"
      },
      {
        Key: "NOTICE",
        Value: "NOTICE"
      }
    ];
    this.module = this.translate.instant("LblErrorEscalation");
    this.duplicateEscalationMsg = this.translate.instant(
      "LblDuplicateErrorEscalation"
    );
    this.LblDuplicateEscalation = "Duplicate Escalation";
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlErrorEscalationList = this.authService.GetURL(
      ApplicationRouteURL.URL_ERROR_ESCALATION_LIST
    );
    this.model = new ErrorEscalationModel();
    this.GetErrorEsclationDropdownList();
  }

  public GetErrorEsclationDropdownList() {
    this.errorEscalationService.GetErrorEsclationDropdownList().subscribe(
      res => {
        this.apiResponse = res;
        this.componentList = res.data.componentDropdownList;
        //this.logTypeList = res.data.logTypeDropdownList;
        this.wegoAdminList = res.data.wegoAdminDropdownList;
        this.GetCustomerList();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetWegoAdminDropDown() {
    this.errorEscalationService.GetErrorEsclationDropdownList(true).subscribe(
      res => {
        this.wegoAdminList = res.data.wegoAdminDropdownList;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetCustomerList() {
    this.customerService.GetCustomerDropdownList().subscribe(
      res => {
        this.apiResponse = res;
        this.customerList = res.data;

        if (this.customerList && this.customerList.length > 0) {
          if (!this.model.customerHashId && this.customerList.length == 1) {
            this.model.customerHashId = this.customerList[0].keyHash;
          }
        }
        this.GetErrorEscalationDetails();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetErrorEscalationDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.errorEscalationHashId = params["id"] || "";
      if (this.errorEscalationHashId != "") {
        this.isLoading = true;
        this.isEditMode = true;
        this.errorEscalationService
          .GetErrorEscalationByHashId(this.errorEscalationHashId)
          .subscribe(
            res => {
              this.model.adminLevel = res.data.adminLevel;
              this.model = res.data;
              this.BindDataOnEdit();

              console.log(res.data);
              this.isLoading = false;
            },
            error => {
              this.isLoading = false;
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
          );
      } else {
        this.isEditMode = false;
        this.model = new ErrorEscalationModel();
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  public BindDataOnEdit() {
    if (this.model.adminLevel == "WEGOADMIN") {
      this.wegoAdminMultiSelect.set(this.model.wegoAdminHashId);
    } else if (this.model.adminLevel == "CUSTOMER") {
      this.bindFirstTime = true;
      this.tempCustomerAdminList = this.model.customerAdminHashId;
      this.OnCustomerChange();
    } else if (this.model.adminLevel == "INSTANCE") {
      this.bindFirstTime = true;
      this.tempInstanceAdminList = this.model.instanceAdminHashId;
      this.GetInstanceBasedOnCustomer();
    }
  }

  public OnInstaceChange() {
    if (this.model.instanceHashId) {
      this.errorEscalationService
        .GetInstanceAdminByInstance(this.model.instanceHashId)
        .subscribe(
          res => {
            this.instanceAdminList = res.data;
            if (this.bindFirstTime) {
              this.bindFirstTime = false;
              this.SetInstanceAdminOnEdit();
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.ClearInstanceAdminDropDown();
    }
  }

  public SetInstanceAdminOnEdit() {
    setTimeout(() => {
      this.instanceAdminMultiSelect.set(this.tempInstanceAdminList);
    }, 100);
  }
  public SetCustomerAdminOnEdit() {
    setTimeout(() => {
      this.customerAdminMultiSelect.set(this.tempCustomerAdminList);
    }, 100);
  }

  public AdminSelectionChange() {
    this.model.componentHashId = "";
    this.model.logType = "";
    this.ClearCustomerAdminDropDown();
    this.ClearWegoAdminDropDown();
    this.ClearInstanceAdminDropDown();
    this.model.instanceHashId = "";
    this.model.customerHashId = "";
    this.OnCustomerChange();
    this.OnInstaceChange();
    if (this.model.adminLevel == "WEGOADMIN") {
      this.GetWegoAdminDropDown();
    }
  }

  public OnCustomerChange() {
    if (this.model.adminLevel == "CUSTOMER") {
      if (this.model.customerHashId) {
        this.errorEscalationService
          .GetCustomerAdminByCustomer(this.model.customerHashId)
          .subscribe(
            res => {
              this.customerAdminList = res.data;
              if (this.bindFirstTime) {
                this.bindFirstTime = false;
                this.SetCustomerAdminOnEdit();
              }
            },
            error => {
              this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            }
          );
      } else {
        this.ClearCustomerAdminDropDown();
      }
    } else {
      this.ClearInstanceDropDown();
      this.ClearInstanceAdminDropDown();
      this.GetInstanceBasedOnCustomer();
    }
  }

  public GetInstanceBasedOnCustomer() {
    let permissionType = "";
    if (this.isEditMode) {
      permissionType = PermissionType.EDIT;
    } else {
      permissionType = PermissionType.INSERT;
    }
    if (this.model.customerHashId) {
      this.instanceService
        .GetInstanceListDropdownForAddUpdatePage(
          "ErrorEsclation",
          permissionType,
          this.model.customerHashId
        )
        .subscribe(
          res => {
            this.apiResponse = res;
            this.instanceList = res.data;
            if (this.isEditMode) {
              this.OnInstaceChange();
            }
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.ClearInstanceDropDown();
      this.ClearInstanceAdminDropDown();
    }
  }

  ngAfterViewInit() {
    this.wegoAdminMultiSelect = new SlimSelect({
      select: "#wegoAdmin",
      placeholder: "Select Wego Admin",
      showSearch: false,
      onChange: (info: any) => {
        this.model.wegoAdminHashId = info.map((x: any) => x.value);
      }
    });

    this.customerAdminMultiSelect = new SlimSelect({
      select: "#customerAdmin",
      placeholder: "Select customer Admin",
      showSearch: false,
      onChange: (info: any) => {
        console.log(this.model.customerAdminHashId);
        this.model.customerAdminHashId = info.map((x: any) => x.value);
      }
    });
    this.instanceAdminMultiSelect = new SlimSelect({
      select: "#instanceAdmin",
      placeholder: "Select Instance Admin",
      showSearch: false,
      onChange: (info: any) => {
        this.model.instanceAdminHashId = info.map((x: any) => x.value);
        console.log(this.model.instanceAdminHashId);
      }
    });
  }

  onSubmit(forms: any) {
    if (this.model.adminLevel == "WEGOADMIN") {
      this.ClearInstanceAdminDropDown();
      this.ClearCustomerAdminDropDown();
    } else if (this.model.adminLevel == "CUTOMER") {
      this.ClearWegoAdminDropDown();
      this.ClearInstanceAdminDropDown();
    } else if (this.model.adminLevel == "INSTANCE") {
      this.ClearWegoAdminDropDown();
      this.ClearCustomerAdminDropDown();
    }
    this.UpdateErrorEscalation();
  }

  public UpdateErrorEscalation() {
    this.errorEscalationService.UpdateErrorEscalation(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
            : this.translate.instant("LblRecordAddedSuccess", [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
          this.CheckDuplicateErrorEscalation();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public CheckDuplicateErrorEscalation() {
    var isDuplicateErrorEscaltion = this.errorModel.find(
      x => x.key == "DuplicateEscalationValidationMessage"
    );
    if (isDuplicateErrorEscaltion != null) {
      this.duplicateEscalationPopup.show(false);
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public ClearCustomerAdminDropDown() {
    this.customerAdminList = [];
    this.model.customerAdminHashId = [];
  }

  public ClearInstanceAdminDropDown() {
    this.instanceAdminList = [];
    this.model.instanceAdminHashId = [];
  }

  public ClearInstanceDropDown() {
    this.instanceList = [];
    this.model.instanceHashId = "";
  }

  public ClearWegoAdminDropDown() {
    this.wegoAdminList = [];
    this.model.wegoAdminHashId = [];
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorescalation-configuration/components/errorescalation-update.component.ts